<template lang='pug'>
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  :items="items"
  item-value='id'
  item-text='name'
)
</template>

<script>
import picker from '@/mixins/picker'

export default {
  data () {
      return {
        items: [
          { id: null , name: 'Не указан' },
          { id: 0 , name: 'Женский' },
          { id: 1 , name: 'Мужской' }
        ],
      }
  },
  mixins: [picker],
  props: {
    label: {
      default: 'Выберите пол'
    }
  },

}
</script>
